var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2156",
    "data-name": "Group 2156",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102.293,
    height: 93.419,
    viewBox: "0 0 102.293 93.419",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 102.293,
    height: 93.419,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2155",
    "data-name": "Group 2155",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 86.18,
    height: 83.93,
    transform: "translate(2.93 6.36)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M90.1,75.572H24.342l0,.2a8.724,8.724,0,0,1-.614,3.209l0,.013-.057.14-.057.132-.008.018a8.9,8.9,0,0,1-1.119,1.878q-.113.144-.231.285H93.513a5.789,5.789,0,0,0,1.388-.164,5.72,5.72,0,0,0,4.3-5.51h-.006l0-.2Zm-67.522-3.1H88.551V6.6H78.486V8.545a1.55,1.55,0,1,1-3.1,0V6.6H64.631V8.545a1.55,1.55,0,1,1-3.1,0V6.6H50.767V8.545a1.55,1.55,0,0,1-3.1,0V6.6H36.908V8.545a1.55,1.55,0,1,1-3.1,0V6.6H23.053V8.545a1.55,1.55,0,1,1-3.1,0V6.6H9.887v70.34A5.6,5.6,0,0,0,11.832,80.1a5.894,5.894,0,0,0,3.733,1.342h.046q.151,0,.3-.009a6.019,6.019,0,0,0,1.008-.162,5.733,5.733,0,0,0,2.91-1.758q.109-.125.211-.256a5.687,5.687,0,0,0,1.2-3.488,5.762,5.762,0,0,0-.143-1.281,1.551,1.551,0,0,1,1.478-2.02M15.6,84.546h-.034A9,9,0,0,1,9.87,82.489,8.677,8.677,0,0,1,6.846,77.48a1.554,1.554,0,0,1-.06-.427V6.6H3.1V90.319H88.551V84.546H15.6Zm77.914,0H91.651v7.323a1.55,1.55,0,0,1-1.55,1.55H1.55A1.55,1.55,0,0,1,0,91.869V5.047A1.55,1.55,0,0,1,1.55,3.5h18.4V1.55a1.55,1.55,0,1,1,3.1,0V3.5H33.808V1.55a1.55,1.55,0,1,1,3.1,0V3.5H47.667V1.55a1.55,1.55,0,0,1,3.1,0V3.5H61.531V1.55a1.55,1.55,0,0,1,3.1,0V3.5H75.386V1.55a1.55,1.55,0,1,1,3.1,0V3.5H90.1a1.55,1.55,0,0,1,1.55,1.55V72.472h8.877v0a1.547,1.547,0,0,1,1.5,1.176,8.8,8.8,0,0,1,.264,2.12h-.006a8.772,8.772,0,0,1-8.774,8.774m-74.9-63.6a1.55,1.55,0,1,1,0-3.1H79.828a1.55,1.55,0,0,1,0,3.1ZM60.137,67.484H52.86a1.55,1.55,0,0,1-1.55-1.55V58.657a1.55,1.55,0,0,1,1.55-1.55h7.277a1.55,1.55,0,0,1,1.55,1.55v7.277a1.55,1.55,0,0,1-1.55,1.55m-14.555,0H38.3a1.55,1.55,0,0,1-1.55-1.55V58.657a1.55,1.55,0,0,1,1.55-1.55h7.279a1.55,1.55,0,0,1,1.55,1.55v7.277a1.55,1.55,0,0,1-1.55,1.55m-14.556,0H23.747a1.55,1.55,0,0,1-1.55-1.55V58.657a1.55,1.55,0,0,1,1.55-1.55h7.279a1.55,1.55,0,0,1,1.55,1.55v7.277a1.55,1.55,0,0,1-1.55,1.55M52.86,42.55h7.277a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H52.86a1.55,1.55,0,0,1-1.55-1.55V44.1a1.55,1.55,0,0,1,1.55-1.55m-14.557,0h7.279a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H38.3a1.55,1.55,0,0,1-1.55-1.55V44.1a1.55,1.55,0,0,1,1.55-1.55m-14.556,0h7.279a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H23.747a1.55,1.55,0,0,1-1.55-1.55V44.1a1.55,1.55,0,0,1,1.55-1.55M52.86,27.994h7.277a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H52.86a1.55,1.55,0,0,1-1.55-1.55V29.544a1.55,1.55,0,0,1,1.55-1.55m-14.557,0h7.279a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H38.3a1.55,1.55,0,0,1-1.55-1.55V29.544a1.55,1.55,0,0,1,1.55-1.55m-14.556,0h7.279a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H23.747a1.55,1.55,0,0,1-1.55-1.55V29.544a1.55,1.55,0,0,1,1.55-1.55M74.691,67.484H67.414a1.55,1.55,0,0,1-1.55-1.55V58.657a1.55,1.55,0,0,1,1.55-1.55h7.277a1.55,1.55,0,0,1,1.55,1.55v7.277a1.55,1.55,0,0,1-1.55,1.55M67.414,42.55h7.277a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H67.414a1.55,1.55,0,0,1-1.55-1.55V44.1a1.55,1.55,0,0,1,1.55-1.55m0-14.556h7.277a1.55,1.55,0,0,1,1.55,1.55v7.278a1.55,1.55,0,0,1-1.55,1.55H67.414a1.55,1.55,0,0,1-1.55-1.55V29.544a1.55,1.55,0,0,1,1.55-1.55",
    transform: "translate(0 0)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M394.175,1108.165H328.416l0,.2a8.723,8.723,0,0,1-.614,3.209l0,.013-.057.14-.057.132-.008.018a8.9,8.9,0,0,1-1.119,1.878q-.113.144-.231.285h71.259a5.778,5.778,0,0,0,1.388-.164,5.719,5.719,0,0,0,4.3-5.51h-.006l0-.2Z",
    transform: "translate(-304.074 -1032.593)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    "data-name": "Rectangle 763",
    width: 4.177,
    height: 4.177,
    transform: "translate(54.41 60.207)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    "data-name": "Rectangle 764",
    width: 4.179,
    height: 4.177,
    transform: "translate(39.853 60.207)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    "data-name": "Rectangle 765",
    width: 4.179,
    height: 4.177,
    transform: "translate(25.298 60.207)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_766",
    "data-name": "Rectangle 766",
    width: 4.177,
    height: 4.178,
    transform: "translate(54.41 45.65)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_767",
    "data-name": "Rectangle 767",
    width: 4.179,
    height: 4.178,
    transform: "translate(39.853 45.65)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_768",
    "data-name": "Rectangle 768",
    width: 4.179,
    height: 4.178,
    transform: "translate(25.298 45.65)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_769",
    "data-name": "Rectangle 769",
    width: 4.177,
    height: 4.178,
    transform: "translate(54.41 31.094)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_770",
    "data-name": "Rectangle 770",
    width: 4.179,
    height: 4.178,
    transform: "translate(39.853 31.094)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 4.179,
    height: 4.178,
    transform: "translate(25.298 31.094)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_772",
    "data-name": "Rectangle 772",
    width: 4.177,
    height: 4.177,
    transform: "translate(68.964 60.207)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_773",
    "data-name": "Rectangle 773",
    width: 4.177,
    height: 4.178,
    transform: "translate(68.964 45.65)",
    fill: "#eeeae7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 4.177,
    height: 4.178,
    transform: "translate(68.964 31.094)",
    fill: "#eeeae7"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.d4a77728d11de9b67c701ce69e044fb2.svg";